import { Flex, Layout, theme, Typography, Grid, Row, Col, Divider } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from '@inscore/shared';

import './appFooter.css';

const { Footer } = Layout;
const { Text } = Typography;
const { useBreakpoint } = Grid;

const AppFooter = ({ children, additionalStoreLink }) => {
    const screens = useBreakpoint();
    const { token } = theme.useToken();
    const { t } = useTranslation();
    const isMobile = !screens.lg;

    return (
        <Footer
            className="app-footer"
            style={{
                backgroundColor: token.colorBgContainer,
                boxShadow: token.boxShadow,
                padding: 0,
                paddingBottom: isMobile ? 24 : 40,
            }}
        >
            <div
                className="container"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: isMobile ? 'flex-start' : 'center',
                    gap: 24,
                }}
            >
                <Row
                    justify="space-between"
                    align="middle"
                    dir={isMobile ? 'vertical' : 'horizontal'}
                    style={{
                        width: '100%',
                        gap: isMobile ? 24 : 0,
                        paddingTop: isMobile ? 24 : 40,
                        paddingInline: isMobile ? 24 : 72,
                    }}
                >
                    <Col xs={24} lg={6} order={1}>
                        <Link to="/">{children}</Link>
                    </Col>

                    <Col xs={24} lg={8} order={isMobile ? 3 : 2}>
                        <Flex
                            gap={isMobile ? 12 : 16}
                            vertical={isMobile}
                            align={'center'}
                            style={{
                                zIndex: 1,
                            }}
                        >
                            {additionalStoreLink}
                        </Flex>
                    </Col>

                    <Col xs={24} lg={6} order={isMobile ? 2 : 3}>
                        <Flex justify="space-between" style={{ width: '100%' }}>
                            <Link
                                to="/privacy-policy"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="link-secondary"
                            >
                                {t('privacy_policy')}
                            </Link>
                            <Link
                                to="/terms-conditions"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="link-secondary"
                            >
                                {t('terms_of_use')}
                            </Link>
                            <Link
                                to="/contact-us"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="link-secondary"
                            >
                                {t('contact_us')}
                            </Link>
                        </Flex>
                    </Col>
                </Row>

                {!isMobile && (
                    <Divider
                        style={{
                            borderColor: token.colorBorder,
                            margin: 0,
                        }}
                    />
                )}
                <Text
                    style={{
                        color: token.colorTextSecondary,
                        paddingInline: isMobile ? 24 : 0,
                    }}
                >
                    {t('copyright')}
                </Text>
            </div>
        </Footer>
    );
};

export default AppFooter;
